import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [showPw, setShowPw] = useState(false);   // ปุ่มลืมตาดูรหัสที่พิมพ์ (Purim: งงว่าพิมพ์ถูกไหม)

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true); setErr('');
    const { error } = await signIn(email.trim(), password);
    if (error) setErr('เข้าสู่ระบบไม่สำเร็จ — ตรวจอีเมล/รหัสผ่านอีกครั้ง');
    setBusy(false);
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="eyebrow">เข้าสู่ระบบ · Sign in</div>
        <h1>ฝ่ายจัดซื้อ</h1>

        <div className="field" style={{ marginTop: 38 }}>
          <div className="lbl"><span className="th">อีเมล</span><span className="en">Email</span></div>
          <input className="under" type="email" autoComplete="username" value={email}
                 onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className="field">
          <div className="lbl"><span className="th">รหัสผ่าน</span><span className="en">Password</span></div>
          <div className="pw-wrap">
            <input className="under" type={showPw ? 'text' : 'password'} autoComplete="current-password"
                   value={password} onChange={e => setPassword(e.target.value)} required />
            <button type="button" className="pw-eye" onClick={() => setShowPw(v => !v)}
                    aria-label={showPw ? 'ซ่อนรหัสผ่าน' : 'ดูรหัสผ่านที่พิมพ์'}
                    title={showPw ? 'ซ่อนรหัสผ่าน' : 'ดูรหัสผ่านที่พิมพ์'}>
              {showPw ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                  <path d="M10.6 6.2A9.8 9.8 0 0112 6c5 0 9 4.5 9 6 0 .8-1.1 2.3-2.8 3.6M6.6 8.5C4.7 9.8 3 11.3 3 12c0 1.5 4 6 9 6 1.2 0 2.3-.3 3.3-.7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                  <path d="M9.9 9.9a3 3 0 004.2 4.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M3 12s4-6 9-6 9 6 9 6-4 6-9 6-9-6-9-6z" stroke="currentColor" strokeWidth="1.6"/>
                  <circle cx="12" cy="12" r="2.6" stroke="currentColor" strokeWidth="1.6"/>
                </svg>
              )}
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <button className="arrow" type="submit" disabled={busy} aria-label="เข้าสู่ระบบ">
            <svg viewBox="0 0 24 24" fill="none"><path d="M7 17L17 7M17 7H9M17 7v8" stroke="#0A0A0A" strokeWidth="1.6"/></svg>
          </button>
          <span style={{ fontFamily: 'var(--thdisplay)', fontWeight: 700, fontSize: 22 }}>เข้าสู่ระบบ</span>
        </div>
        <p className="err-note">{err}</p>

        <p className="login-note">
          ใช้บัญชีเดียวกับแอป Pre-Order (Supabase) — สิทธิ์ดูต้นทุน/แก้ไขซัพพลายเออร์เฉพาะ role
          จัดซื้อ (purchasing) และผู้จัดการ (manager)
        </p>
      </form>
    </div>
  );
}
